import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const borghiApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBorgo: builder.query({
      query: (name) => ({
        url: API_PREFIX + "/borgo/" + name,
        method: "GET",
      }),
      providesTags: ["Borgo"],
      invalidatesTags: ["Borgo"],
    }),
    getBorgoSections: builder.query({
      query: (name) => ({
        url: API_PREFIX + "/borgo/sections/" + name,
        method: "GET",
      }),
    }),
    getAllBorghi: builder.query({
      query: (name) => ({
        url: API_PREFIX + "/borgo/list/all/",
        method: "GET",
      }),
    }),
    getBorghiHighlights: builder.query({
      query: () => ({
        url: API_PREFIX + "/borgo/highlights",
        method: "GET",
      }),
    }),
    createBorgo: builder.mutation({
      query: (values) => ({
        url: API_PREFIX + "/borgo/create",
        method: "POST",
        body: values,
      }),
      invalidatesTags: ["Borgo"],
    }),
    uploadBorgoCover: builder.mutation({
      query: (formData) => ({
        url: API_PREFIX + "/borgo/upload/cover",
        method: "POST",
        body: formData,
      }),
    }),
    getAmenities: builder.query({
      query: () => ({
        url: API_PREFIX + "/borgo/list/amenities",
        method: "GET",
      }),
    }),
    addAmenitiesToBorgo: builder.mutation({
      query: (values) => ({
        url: API_PREFIX + "/borgo/add/amenities",
        method: "POST",
        body: values,
      }),
    }),
  }),
});

export const {
  useGetBorgoQuery,
  useLazyGetBorgoQuery,
  useGetBorgoSectionsQuery,
  useLazyGetBorgoSectionsQuery,
  useGetAllBorghiQuery,
  useGetBorghiHighlightsQuery,
  useCreateBorgoMutation,
  useUploadBorgoCoverMutation,
  useGetAmenitiesQuery,
  useAddAmenitiesToBorgoMutation,
} = borghiApiSlice;
